module.exports = __webpack_public_path__ + "img/djdd.a2814996.png";